import EditThiSensorModal from "./edit-thi-sensor-modal.vue";

export default EditThiSensorModal;



// WEBPACK FOOTER //
// ./src/components/_modals/edit-thi-sensor/index.js